import { IGenericJSON } from '../helpers/interface';

export class User {
  id: number;
  googleId: number;
  email: string;
  userType: string;
  firstName: string;
  lastName: string;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
  agreementAgreedAt: string | null;
  counselorUserId: number | null;
  preferredName: string;
  permissions: string[];
  isAdmin: boolean;
  /** Name of the user's school, when the response includes it (e.g. post authors). */
  schoolName: string | null;
  /** Saved avatar image URL, when the response includes a Profile (null if none saved). */
  profilePicturePath: string | null;

  constructor(data: IGenericJSON) {
    this.id = data['id'];
    this.googleId = data['googleId'];
    this.email = data['email'];
    this.userType = data['user_type'];
    this.firstName = data['first_name'];
    this.lastName = data['last_name'];
    this.isActive = data['is_active'];
    this.createdAt = data['created_at'];
    this.updatedAt = data['updated_at'];
    this.agreementAgreedAt = data['agreement_agreed_at'] ?? null;
    this.preferredName = data['preferredName'] ?? data['first_name'];
    this.counselorUserId = data['Student']?.counselor?.id ?? null;
    this.permissions = data['permissions'] ?? [];
    this.schoolName = data['School']?.name ?? null;
    this.profilePicturePath = data['Profile']?.profile_picture_path ?? null;

    const roles = data['Roles'] ?? [];
    this.isAdmin = roles.some((r: IGenericJSON) => r['name'] === 'Admin');
  }

  hasPermission(permission: string): boolean {
    if (this.isAdmin) return true;
    return this.permissions.includes(permission);
  }

  hasAnyPermission(permissions: string[]): boolean {
    if (this.isAdmin) return true;
    return permissions.some((p) => this.permissions.includes(p));
  }

  public static digest(data: IGenericJSON): User {
    return new User(data);
  }

  public static digestResponse(data: IGenericJSON[]): User[] {
    const ret: User[] = [];

    data.forEach((u: IGenericJSON): void => {
      ret.push(this.digest(u));
    });

    return ret;
  }
}
